import React from 'react';
import LogoFull from '../../../assets/images/layout4/logo_full_white.png';
import LogoSmall from '../../../assets/images/layout4/logo_white.png';
import styled from "styled-components";
import {useSelector} from "react-redux";


const Nav = styled.nav`
  background-color: #222222 !important;
  &.minimized {
    width: 70px !important;
    .sub-menu-items li > a {
      padding-left: 25px !important;
    }
    .menu-items > li {
      margin-top: 25px;
      & > a {
        font-size: 0 !important;
        i {
          font-size: 20px !important;
        }
      }
    }
  }
  &:not(.minimized) {
    .sub-menu-items li > a {
      padding-left: 14px !important;
    }
  }
  .sub-menu-items li {
    padding-left: 0px !important;
    & > a {
      &:before {
        content: none !important;
      }
    }
    &:after {
      content: none !important;
    }
  }
`

function Navbar({children}) {
  const navbarSmall = useSelector(state => state.layout.navbarSmall);

  return (
    <Nav id="side-menu" className={`${navbarSmall ? 'minimized' : ''}`}>
      <div className="side-menu-content">
        <div className="page-logo spt-logo">
          <a href="/">
            <img src={LogoFull} alt="logo" className="logo-default"/>
            <img src={LogoSmall} alt="logo" className="logo-small"/>
          </a>
        </div>
        <ul className="list-unstyled menu-items" id="side-menu-ul">
          {children}
        </ul>
        <footer className="footer"/>
      </div>
    </Nav>
  )
}

export default Navbar



